// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KFE3","question":"styles_question__6H4EF","description":"styles_description__3iAvb"};